import { render, staticRenderFns } from "./ReportShipments.vue?vue&type=template&id=36fe8718&"
import script from "./ReportShipments.vue?vue&type=script&lang=js&"
export * from "./ReportShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports